import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { AppendableFormatStructure38mt32f1b8qva as AppendableFormatStructure } from '../internal/format/Builder.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  appendAlternativeParsingImpl1mug8j87kp2j3 as appendAlternativeParsingImpl,
  appendOptionalImplcg29ds00y54b as appendOptionalImpl,
  chars1g48a4lypizqb as chars,
  build284bs2tzkjm2x as build,
  day$default1tuwold9wyz96 as day$default,
  year$default3mx8s1e4np76f as year$default,
  monthNumber$defaultjiqg7b70p9la as monthNumber$default,
  hour$default3ltjmfc740vqh as hour$default,
  minute$defaultsgib3pp3rn60 as minute$default,
  second$defaultabrspkhk2hrb as second$default,
  AbstractDateTimeFormatBuilder2kkelk07l4wb as AbstractDateTimeFormatBuilder,
  WithTime2lgb7k6hqa1zi as WithTime,
  WithDate2bqihss8t5xfv as WithDate,
  alternativeParsing1gmwubnsvpp9b as alternativeParsing,
  char1r4ssccmdfesy as char,
} from './DateTimeFormatBuilder.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  addFormatStructureForYearMonth2jef3q6pdb658 as addFormatStructureForYearMonth,
  day1ffm1rpsbzq2v as day,
  dayOfWeek16trujebvwhwq as dayOfWeek,
  date3ki45iw426xr8 as date,
  IncompleteLocalDate2wlnrm8wqbjky as IncompleteLocalDate,
  AbstractWithDateBuilder1xwo9aqwqe32f as AbstractWithDateBuilder,
  get_ISO_DATE1ah0stqy13618 as get_ISO_DATE,
} from './LocalDateFormat.mjs';
import {
  year1lgww3hq6k77h as year,
  monthNumber1m6x1k5hwwmv0 as monthNumber,
  monthName3sdgh7ilodr1v as monthName,
} from './YearMonthFormat.mjs';
import {
  hour31jxjrzfyqe0i as hour,
  minute2dqmds23fogn6 as minute,
  secondq4lhw2ppe1iv as second,
  secondFraction17r4cie9ncxw as secondFraction,
  time3kvfctmdykstm as time,
  IncompleteLocalTime3h4nusjwtlckd as IncompleteLocalTime,
  TimeFieldContainer3bsvpq7sk70go as TimeFieldContainer,
  AbstractWithTimeBuilder2vqnew72ok0ro as AbstractWithTimeBuilder,
  get_ISO_TIME31n00f6uljtbs as get_ISO_TIME,
} from './LocalTimeFormat.mjs';
import { AbstractDateTimeFormat1er9ki1vjeb1b as AbstractDateTimeFormat } from './DateTimeFormat.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { LocalDateTime3vqv9moe7clf4 as LocalDateTime } from '../LocalDateTime.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ISO_DATETIME() {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  var tmp0 = ISO_DATETIME$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_DATETIME', 0, tmp, _get_ISO_DATETIME_$ref_5bxm11(), null);
  return tmp0.get_value_j01efc_k$();
}
var ISO_DATETIME$delegate;
function get_emptyIncompleteLocalDateTime() {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  return emptyIncompleteLocalDateTime;
}
var emptyIncompleteLocalDateTime;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      build_jyqq35_k$(block) {
        var builder = new (Builder())(new (AppendableFormatStructure())());
        block(builder);
        return new (LocalDateTimeFormat())(builder.build_1k0s4u_k$());
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(actualBuilder) {
        this.actualBuilder_1 = actualBuilder;
      }
      get_actualBuilder_7qypdo_k$() {
        return this.actualBuilder_1;
      }
      addFormatStructureForDateTime_noiy5b_k$(structure) {
        this.actualBuilder_1.add_b6pdwl_k$(structure);
      }
      createEmpty_8k9z67_k$() {
        return new (Builder())(new (AppendableFormatStructure())());
      }
    }
    protoOf($).appendAlternativeParsingImpl_9hljk3_k$ = appendAlternativeParsingImpl;
    protoOf($).appendOptionalImpl_725ywl_k$ = appendOptionalImpl;
    protoOf($).chars_pe6iqb_k$ = chars;
    protoOf($).build_1k0s4u_k$ = build;
    protoOf($).addFormatStructureForDate_t2v9hh_k$ = addFormatStructureForDate;
    protoOf($).addFormatStructureForTime_h3r7lv_k$ = addFormatStructureForTime;
    protoOf($).addFormatStructureForYearMonth_t4rp63_k$ = addFormatStructureForYearMonth;
    protoOf($).day_pu15qg_k$ = day;
    protoOf($).day$default_z5jqi1_k$ = day$default;
    protoOf($).dayOfWeek_tn8lxa_k$ = dayOfWeek;
    protoOf($).date_aq11yp_k$ = date;
    protoOf($).year_dmdaiv_k$ = year;
    protoOf($).year$default_dp2ctv_k$ = year$default;
    protoOf($).monthNumber_xjkdp7_k$ = monthNumber;
    protoOf($).monthNumber$default_9sd2sh_k$ = monthNumber$default;
    protoOf($).monthName_asbkgr_k$ = monthName;
    protoOf($).hour_cqw3y8_k$ = hour;
    protoOf($).hour$default_ke0z0o_k$ = hour$default;
    protoOf($).minute_p09m40_k$ = minute;
    protoOf($).minute$default_r7oarc_k$ = minute$default;
    protoOf($).second_rj6d1s_k$ = second;
    protoOf($).second$default_ix75t4_k$ = second$default;
    protoOf($).secondFraction_6m5e86_k$ = secondFraction;
    protoOf($).time_eev9o3_k$ = time;
    initMetadataForClass($, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder(), AbstractWithDateTimeBuilder()]);
    BuilderClass = $;
  }
  return BuilderClass;
}
var LocalDateTimeFormatClass;
function LocalDateTimeFormat() {
  if (LocalDateTimeFormatClass === VOID) {
    class $ extends AbstractDateTimeFormat() {
      constructor(actualFormat) {
        super();
        this.actualFormat_1 = actualFormat;
      }
      get_actualFormat_d0ha3y_k$() {
        return this.actualFormat_1;
      }
      intermediateFromValue_tbwf47_k$(value) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (IncompleteLocalDateTime())();
        this_0.populateFrom_ss78ub_k$(value);
        return this_0;
      }
      intermediateFromValue_816pep_k$(value) {
        return this.intermediateFromValue_tbwf47_k$(value instanceof LocalDateTime() ? value : THROW_CCE());
      }
      valueFromIntermediate_v22dn7_k$(intermediate) {
        return intermediate.toLocalDateTime_5q5ehh_k$();
      }
      valueFromIntermediate_60ox3m_k$(intermediate) {
        return this.valueFromIntermediate_v22dn7_k$(intermediate instanceof IncompleteLocalDateTime() ? intermediate : THROW_CCE());
      }
      get_emptyIntermediate_lysuyr_k$() {
        return get_emptyIncompleteLocalDateTime();
      }
    }
    initMetadataForClass($, 'LocalDateTimeFormat');
    LocalDateTimeFormatClass = $;
  }
  return LocalDateTimeFormatClass;
}
var IncompleteLocalDateTimeClass;
function IncompleteLocalDateTime() {
  if (IncompleteLocalDateTimeClass === VOID) {
    class $ {
      constructor(date, time) {
        date = date === VOID ? new (IncompleteLocalDate())() : date;
        time = time === VOID ? new (IncompleteLocalTime())() : time;
        this.date_1 = date;
        this.time_1 = time;
      }
      toLocalDateTime_5q5ehh_k$() {
        return LocalDateTime().new_kotlinx_datetime_LocalDateTime_zaqrue_k$(this.date_1.toLocalDate_u88f42_k$(), this.time_1.toLocalTime_u7y1k3_k$());
      }
      populateFrom_ss78ub_k$(dateTime) {
        this.date_1.populateFrom_bxnzqu_k$(dateTime.date_1);
        this.time_1.populateFrom_auih6d_k$(dateTime.time_1);
      }
      copy_1tks5_k$() {
        return new (IncompleteLocalDateTime())(this.date_1.copy_1tks5_k$(), this.time_1.copy_1tks5_k$());
      }
      set_day_420fh8_k$(_set____db54di) {
        this.date_1.day_1 = _set____db54di;
      }
      get_day_18j7il_k$() {
        return this.date_1.day_1;
      }
      set_dayOfWeek_rlg9ap_k$(_set____db54di) {
        this.date_1.dayOfWeek_1 = _set____db54di;
      }
      get_dayOfWeek_3kfgci_k$() {
        return this.date_1.dayOfWeek_1;
      }
      set_dayOfYear_b6dvlk_k$(_set____db54di) {
        this.date_1.dayOfYear_1 = _set____db54di;
      }
      get_dayOfYear_3ke6gp_k$() {
        return this.date_1.dayOfYear_1;
      }
      set_year_8yykwv_k$(_set____db54di) {
        this.date_1.set_year_8yykwv_k$(_set____db54di);
      }
      get_year_woy26e_k$() {
        return this.date_1.get_year_woy26e_k$();
      }
      set_monthNumber_nufdv5_k$(_set____db54di) {
        this.date_1.set_monthNumber_nufdv5_k$(_set____db54di);
      }
      get_monthNumber_nb47ls_k$() {
        return this.date_1.get_monthNumber_nb47ls_k$();
      }
      set_minute_35xlhm_k$(_set____db54di) {
        this.time_1.minute_1 = _set____db54di;
      }
      get_minute_gnc10d_k$() {
        return this.time_1.minute_1;
      }
      set_second_5q0zme_k$(_set____db54di) {
        this.time_1.second_1 = _set____db54di;
      }
      get_second_jf7fjx_k$() {
        return this.time_1.second_1;
      }
      set_nanosecond_xpjfxy_k$(_set____db54di) {
        this.time_1.nanosecond_1 = _set____db54di;
      }
      get_nanosecond_fws9td_k$() {
        return this.time_1.nanosecond_1;
      }
      set_hour_cn99tm_k$(_set____db54di) {
        this.time_1.hour_1 = _set____db54di;
      }
      get_hour_wonfal_k$() {
        return this.time_1.hour_1;
      }
      set_hourOfAmPm_4kn0va_k$(_set____db54di) {
        this.time_1.hourOfAmPm_1 = _set____db54di;
      }
      get_hourOfAmPm_c9obsj_k$() {
        return this.time_1.hourOfAmPm_1;
      }
      set_amPm_20li4z_k$(_set____db54di) {
        this.time_1.amPm_1 = _set____db54di;
      }
      get_amPm_woiw0i_k$() {
        return this.time_1.amPm_1;
      }
      set_fractionOfSecond_45hz7f_k$(value) {
        this.time_1.set_fractionOfSecond_45hz7f_k$(value);
      }
      get_fractionOfSecond_3ubmju_k$() {
        return this.time_1.get_fractionOfSecond_3ubmju_k$();
      }
    }
    initMetadataForClass($, 'IncompleteLocalDateTime', IncompleteLocalDateTime, VOID, [TimeFieldContainer()]);
    IncompleteLocalDateTimeClass = $;
  }
  return IncompleteLocalDateTimeClass;
}
function addFormatStructureForDate(structure) {
  this.addFormatStructureForDateTime_noiy5b_k$(structure);
}
function addFormatStructureForTime(structure) {
  this.addFormatStructureForDateTime_noiy5b_k$(structure);
}
var AbstractWithDateTimeBuilderClass;
function AbstractWithDateTimeBuilder() {
  if (AbstractWithDateTimeBuilderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'AbstractWithDateTimeBuilder', VOID, VOID, [AbstractWithDateBuilder(), AbstractWithTimeBuilder(), WithTime(), WithDate()]);
    AbstractWithDateTimeBuilderClass = $;
  }
  return AbstractWithDateTimeBuilderClass;
}
function ISO_DATETIME$delegate$lambda() {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  var tmp = Companion_instance;
  return tmp.build_jyqq35_k$(ISO_DATETIME$delegate$lambda$lambda);
}
function ISO_DATETIME$delegate$lambda$lambda($this$build) {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  $this$build.date_aq11yp_k$(get_ISO_DATE());
  var tmp = [ISO_DATETIME$delegate$lambda$lambda$lambda];
  alternativeParsing($this$build, tmp, ISO_DATETIME$delegate$lambda$lambda$lambda_0);
  $this$build.time_eev9o3_k$(get_ISO_TIME());
  return Unit_instance;
}
function ISO_DATETIME$delegate$lambda$lambda$lambda($this$alternativeParsing) {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  char($this$alternativeParsing, _Char___init__impl__6a9atx(116));
  return Unit_instance;
}
function ISO_DATETIME$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  char($this$alternativeParsing, _Char___init__impl__6a9atx(84));
  return Unit_instance;
}
function _get_ISO_DATETIME_$ref_5bxm11() {
  return constructCallableReference(() => get_ISO_DATETIME(), 0, 0, 31);
}
var properties_initialized_LocalDateTimeFormat_kt_67ys6r;
function _init_properties_LocalDateTimeFormat_kt__aloigl() {
  if (!properties_initialized_LocalDateTimeFormat_kt_67ys6r) {
    properties_initialized_LocalDateTimeFormat_kt_67ys6r = true;
    ISO_DATETIME$delegate = lazy(ISO_DATETIME$delegate$lambda);
    emptyIncompleteLocalDateTime = new (IncompleteLocalDateTime())();
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance7gy4c97td3qb,
  get_ISO_DATETIME as get_ISO_DATETIME2pryl9hy3c2kg,
};
//endregion

//# sourceMappingURL=LocalDateTimeFormat.mjs.map
